import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.transactionTypesOptions.filter(option => option.key == _vm.transactionType)),function(tranTypeOption){return _c('div',{key:tranTypeOption.key},[_c('span',{staticStyle:{"height":"30px","float":"left","margin-right":"12px"}},[_c(VImg,{staticStyle:{"display":"inline-block"},attrs:{"max-height":"30","width":"30","contain":"","src":tranTypeOption.icon}})],1),_c('span',{style:({
        'font-size': '14px',
        'line-height': '30px',
        height: '30px',
        color: tranTypeOption.color
      })},[_vm._v(" "+_vm._s(tranTypeOption.shortText)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }